module.exports = __webpack_public_path__ + "static/media/schedule.4a030f2e.svg";